import { render, staticRenderFns } from "./showExampaper.vue?vue&type=template&id=58fc9be2&scoped=true"
import script from "./showExampaper.vue?vue&type=script&lang=js"
export * from "./showExampaper.vue?vue&type=script&lang=js"
import style0 from "./showExampaper.vue?vue&type=style&index=0&id=58fc9be2&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc9be2",
  null
  
)

export default component.exports